import { Component, Inject, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent {
  title: string;
  message: string;
  confirmData: string;
  closeBtnText: string;
  givenIcon: string;

  constructor(
    private transloco: TranslocoService,
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogModel,
  ) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.confirmData = data.confirmData || '';
    this.closeBtnText = data.closeBtnText || '';
    this.givenIcon = data.givenIcon || '';
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}

export class MessageDialogModel {
  constructor(
    public title: string,
    public message: string,
    public confirmData?: string,
    public closeBtnText?: string,
    public givenIcon?: string,
  ) {
    if (!confirmData) {
      this.confirmData = '';
    }
  }
}
